<template>
  <div class="shareParent">
    <div class="share">
      <OverlayModal class="overlayModal" :showmodal="showmodal" @controlOverlay="controlOverlay"></OverlayModal>
    </div>
    <van-overlay class="shareOverlay" :show="showshare">
      <img class="shareImg" :src="imgsrc" />
      <div hidden>
        <vue-canvas-poster :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      </div>
      <div class="btnView">
        <p v-if="_getBrowser()== 1" class="shareText">查看海报可长按图片进行分享</p>
        <p v-else class="shareText">长按海报可进行图片分享</p>
        <div class="shareBtnView">
          <!-- 微信端 只显示立即分享按钮 -->
          <div v-if="_getBrowser()==1" @click="previewImg" class="shareBtn shareBtn2">
            <p class="shareBtnText">查看海报</p>
          </div>
          <div @click="shareLink" class="shareBtn">
            <p class="shareBtnText">立即分享</p>
          </div>
        </div>
      </div>
    </van-overlay>
    <Phone v-if="isphone && myUserInfo.isbindtel == 0" v-on:closePhone="closePhone" v-on:changeBind="changeBind"></Phone>
  </div>
</template>
<script>
import Vue from "vue";
import CanvasPoster from "vue-canvas-poster";
import OverlayModal from "../components/OverlayModal.vue";
import { Overlay } from "vant";
import config from "../config.js";
import Phone from "../components/Phone.vue";
Vue.use(Overlay);
Vue.use(CanvasPoster, OverlayModal);
export default {
  name: "Share",
  components: { OverlayModal, Phone },
  props: ["params"],
  data() {
    return {
      imgsrc: "",
      painting: {},
      showmodal: false, //分享遮罩
      showshare: true,
      isphone: false
    };
  },
  mounted() {
    this.getBaseUser();
  },
  methods: {
    //海报生成成功回调
    success(src) {
      this.imgsrc = src;
    },
    //海报生成失败回调
    fail(err) {
      console.log(err);
    },
    //获取用户基本信息
    async getBaseUser() {
      var _this = this;
      var userid = 0;
      var app_login_user = localStorage.getItem(config.login_key);
      if (app_login_user) app_login_user = JSON.parse(app_login_user);
      if (app_login_user.userid) {
        userid = app_login_user.userid;
      }
      var code_url = `${_this._getInitUrl().roothref}index.html#/?a=${
        _this._getAPPParams().activity_id
      }&sid=${userid}`;
      console.warn(code_url);
      _this.url = code_url; //二维码链接地址
      _this.vowText = _this.params.vowtext; //愿望文本
      _this.avatar = require("../../static/images/avatar.png"); //默认头像
      _this.nickname = ""; //默认昵称
      // _this.vowImg = require("../../static/images/share_bg2.jpg"); //海报背景
      _this.vowTextBg = require("../../static/images/post01.png"); //愿望文字背景
      // _this.vowText = "计算愿望长度，中文两个字符占位";
      var Vlen = 0; //计算愿望长度，中文两个字符占位，英文数字一个字符占位。超过30为换行
      for (var i = 0; i < _this.vowText.length; i++) {
        if ((_this.vowText.charCodeAt(i) & 0xff00) != 0) {
          Vlen++;
        }
        Vlen++;
      }
      var params = {
        rec_uid: _this._getAPPParams().share_userid,
        activity_id: _this._getAPPParams().activity_id
      };
      await _this._signup("user", "User.getUserInfo", params).then(res => {
        if (res.status == 0) {
          var myuser = res.data.user;
          if (myuser.avatar)
            _this.avatar = myuser.avatar.replace("http", "https");
          if (myuser.nickname) _this.nickname = myuser.nickname;
        }
      });
      let painting = {
        width: 670,
        height: 960,
        views: [
          {
            type: "image",
            url: _this.vowImg,
            left: 0,
            top: 0,
            width: 670,
            height: 960
          },
          {
            type: "image",
            url: _this.avatar,
            left: 40,
            top: 40,
            width: 76,
            height: 76,
            radius: 38
          },
          {
            type: "text",
            content: _this.nickname,
            fontSize: 26,
            bolder: true,
            top: 60,
            left: 130,
            width: 490,
            lineHeight: 34,
            color: "#ffffff",
            breakWord: true,
            MaxLineNumber: 1
          },
          {
            type: "image",
            url: _this.vowTextBg,
            left: 35,
            top: 170,
            width: 600,
            height: 130
          },
          {
            type: "text",
            content: _this.vowText,
            fontSize: 30,
            bolder: true,
            top: Vlen > 30 ? 192 : 212, //212, 计算占位符，超过30则为两行，高度上移
            left: 335,
            width: 490,
            lineHeight: 44,
            color: "#ffffff",
            textAlign: "center",
            breakWord: true,
            MaxLineNumber: 2
          },
          {
            type: "rect",
            bolder: true,
            left: 490,
            top: 720,
            width: 140,
            height: 140,
            background: "#fff"
          },
          {
            type: "qrcode",
            content: _this.url,
            background: "#fff",
            color: "#000",
            left: 496,
            top: 726,
            width: 128,
            height: 128
          }
        ]
      };
      _this.painting = painting;
    },
    //分享链接
    shareLink() {
      this._deepmain(this.pageId, "poster#shareclick", 2);
      if (this._getBrowser() == 1) {
        this._sharelink();
      } else {
        if (this.myUserInfo.isbindtel == 0) {
          this.isphone = true;
          return;
        }
        this.showmodal = true;
      }
    },
    //app预览海报
    previewImg() {
      try {
        Jegotrip.articlePictureShareResp(this.imgsrc);
        this._deepmain(this.pageId, "poster#posterpic", 2);
      } catch (e) {}
    },
    //遮罩层控制
    controlOverlay(status) {
      this.showmodal = status;
    }
  }
};
</script>
<style scoped lang="scss" src="../../static/scss/share.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>